import { Outlet } from '@tanstack/react-router';
import Header from './Header';

export default function WatchlistLayout() {
  return (
    <div className="min-h-screen bg-background-main text-gray-text">
      <Header />
      <main className="mx-auto max-w-224 px-l py-2xl">
        <Outlet />
      </main>
    </div>
  );
}
